import React, { useState } from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;

const DataList = ({ data, handleSort, getAllinvitedData }) => {
  const [expandedProviders, setExpandedProviders] = useState({});

  const toggleRow = (providerId) => {
    setExpandedProviders((prev) => ({
      ...prev,
      [providerId]: !prev[providerId],
    }));
  };

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th className="w-10"></Th>
              <Th onClick={(e) => handleSort(e, "provider_trading_name")}>
                <span className="flex items-center gap-1 cursor-pointer">
                  Provider
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "provider_trading_name" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>Provider type</Th>
              <Th>Documents no.</Th>
              <Th>Status</Th>
              <Th onClick={(e) => handleSort(e, "completion_rate")}>
                <span className="flex items-center gap-1 cursor-pointer">
                  Completion rate
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "completion_rate" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "expiry_date")}>
                <span className="flex items-center gap-1 cursor-pointer">
                  Expiry date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "expiry_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {data?.DocsReport?.length > 0 &&
              data?.DocsReport?.map((item, index) => {
                const isExpanded = !!expandedProviders[item.provider_org_id];
                return (
                  <React.Fragment key={index}>
                    <Tr className={isExpanded ? "bg-gray-50/30" : ""}>
                      <Td className="w-10 text-center">
                        <button
                          onClick={() => toggleRow(item.provider_org_id)}
                          className="p-1 hover:bg-gray-100 rounded-full transition-colors duration-150 focus:outline-none"
                        >
                          <svg
                            className={`w-5 h-5 text-gray-500 transform transition-transform duration-200 ${
                              isExpanded ? "rotate-90" : ""
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </Td>

                      <Td className="font-medium text-gray-900">{item?.provider_trading_name}</Td>
                      <Td>{item?.provider_type_name}</Td>
                      <Td>{item?.total_checklist_docs || 0}</Td>
                      <Td>
                        <span
                          className={
                            item?.status === "Approved"
                              ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                              : item?.status === "Action required" || item?.status === "	Action required"
                              ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                              : item?.status === "Awaiting review"
                              ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                              : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                          }
                        >
                          {item?.status}
                        </span>
                      </Td>
                      <Td>
                        <div className="flex items-center gap-2">
                          <div className="w-24 bg-gray-200 rounded-full h-2.5">
                            <div
                              className="bg-blue-600 h-2.5 rounded-full"
                              style={{
                                width: `${Number(item?.completion_rate || 0).toFixed(2)}%`,
                              }}
                            ></div>
                          </div>
                          <span className="text-xs text-gray-600">
                            {`${Number(item?.completion_rate || 0).toFixed(2)}%`}
                          </span>
                        </div>
                      </Td>
                      <Td>
                        {item?.expiry_date
                          ? moment(item?.expiry_date).format("DD/MM/YYYY")
                          : "-"}
                      </Td>
                    </Tr>
                    {isExpanded && (
                      <Tr className="bg-gray-50/50">
                        <Td colSpan={7} className="p-0">
                          <div className="p-6 border-b border-gray-100 bg-[#FCFDFD]">
                            <div className="overflow-hidden border rounded-lg border-gray-100 shadow-sm bg-white">
                              <table className="min-w-full divide-y divide-gray-100">
                                <thead className="bg-gray-50">
                                  <tr>
                                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Document Type</th>
                                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Document Name</th>
                                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Status</th>
                                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Approval Date</th>
                                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Expiry Date</th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 bg-white">
                                  {item.documents && item.documents.length > 0 ? (
                                    item.documents.map((doc, docIdx) => (
                                      <tr key={docIdx} className="hover:bg-gray-50/50">
                                        <td className="px-4 py-2.5 text-xs text-gray-900 font-medium">
                                          {doc.document_type_name || "-"}
                                        </td>
                                        <td className="px-4 py-2.5 text-xs text-gray-600">
                                          {doc.document_name || "-"}
                                        </td>
                                        <td className="px-4 py-2.5 text-xs">
                                          <span
                                            className={
                                              doc.status === "Approved"
                                                ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                                                : doc.status === "Awaiting review"
                                                ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                                                : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                            }
                                          >
                                            {doc.status || "Action required"}
                                          </span>
                                        </td>
                                        <td className="px-4 py-2.5 text-xs text-gray-500">
                                          {doc.approval_date && doc.approval_date !== "-" && doc.approval_date !== "null" && doc.approval_date !== null
                                            ? moment(doc.approval_date).format("DD/MM/YYYY")
                                            : "-"}
                                        </td>
                                        <td className="px-4 py-2.5 text-xs text-gray-500">
                                          {doc.expiry_date && doc.expiry_date !== "-" && doc.expiry_date !== "null" && doc.expiry_date !== null
                                            ? moment(doc.expiry_date).format("DD/MM/YYYY")
                                            : "-"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={5} className="px-4 py-3 text-center text-xs text-gray-400">
                                        No documents found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Td>
                      </Tr>
                    )}
                  </React.Fragment>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default DataList;
